module.exports = __webpack_public_path__ + "img/plus.0468d80c.svg";